import { fromJS } from 'immutable';
import { SET_THEME, DEFAULT_THEME } from './constants';
import { setLocalStorage } from '../../utils/localStorage';

const initialState = fromJS({
  theme: DEFAULT_THEME,
});

/**
 * Define the reducer with actions
 *
 * @param {Object} state
 * @param {Object} action
 */
function ThemeReducer(state = initialState, action) {
  switch (action.type) {
    case SET_THEME:
      setLocalStorage('app_theme', action.data);
      return state.set('theme', action.data);

    default:
      return state;
  }
}

export default ThemeReducer;
